import ExportWorkflow from '../../../../components/workflows/general/export-workflow';

class ExportAll extends ExportWorkflow {
    constructor(Alert, $http, $uibModal, $translate) {
        super('contacts', Alert, $http, $uibModal, $translate);
        this.key = `export-all-contacts`;
        this.level = 'highlight';
        this.icon = 'upload';
    }

    action(payload, store) {
        store.commit('setSelectAll', true);
        super.action(payload, store).finally(()=>{
            store.commit('setSelectAll', false);
        });
    }
}

angular
    .module('festzelt-os.contacts')
    .factory('exportAllContacts', [
        'Alert',
        '$http',
        '$uibModal',
        '$translate',
        (Alert, $http, $uibModal, $translate) => new ExportAll(Alert, $http, $uibModal, $translate)
    ])



// WEBPACK FOOTER //
// ./src/app/pages/contacts/workflows/list-view/export-all-contacts.js